// extracted by mini-css-extract-plugin
module.exports = {"question-title":"style_question-title__0tQs_"};